import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, ITicketingState, TicketingActionCreators, ITicketResponse, ICenterState, ITicketLookupDataResponse } from '@nkr/store/index';
import { ITicketMessage, IListItem, IBaseResponse } from '@nkr/models/index';
import { Button, FormControl, FormGroup, Panel, Table, HelpBlock, ControlLabel, Well } from 'react-bootstrap';
import Message from '../message';
import styled from 'styled-components';
import { TicketType, TicketProperty, MessageType } from '@nkr/enums/index';
import { toast } from 'react-toastify';
import MyUploader from '../../file-upload';

// const TableWrapper = styled(Table)`
//     border-radius: 4px;

//     & > tbody > tr > td {
//         width: 14%;
//         text-align: center;
//     }
// `;

const DataSectionWrapper = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const LabelWrapper = styled.label`
    font-weight: bold;
    margin-bottom: 0px;
`;

const DataWrapper = styled.div``;

interface IProps {
    id: number,
    centerId: number
}

interface IStateProps {
    ticketing: ITicketingState,
    centers: ICenterState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getTicket: (ticketId: number) => Promise<ITicketResponse>,
    getLookupData: () => Promise<ITicketLookupDataResponse>,
    updateCenterTicket: (id: number, subject: string, message: string, files: File[]) => Promise<ITicketResponse>,
    updateTicket: (property: TicketProperty, value: string) => void,
    saveTicketProperties: () => Promise<IBaseResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    subject: string,
    subjectValid: boolean,
    message: string,
    messageValid: boolean,
    files: File[],
    ticketType: TicketType,
    ticketTypes: IListItem[]
    dirty: boolean
}

class ViewCenterTicket extends React.Component<TProps, IState> {
    readonly state: IState = {
        subject: '',
        subjectValid: true,
        message: '',
        messageValid: true,
        files: [],
        ticketType: null,
        ticketTypes: [],
        dirty: false
    }

    componentDidMount = () => {
        this.getData();
    }

    handleReturnToList = () => {
        window.location.href = `/center/${this.props.centerId}/action-center/support`;
    }

    handleSubjectChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            subject: e.currentTarget.value
        });
    }

    handleMessageChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            message: e.currentTarget.value
        });
    }

    handleStatusChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.props.updateTicket(TicketProperty.TicketStatus, e.currentTarget.value);

        this.props.saveTicketProperties().then(response => {
            this.setState({
                dirty: false
            }, () => {
                this.props.hideLoading();

                if (response.data.success) {
                    toast.success('Saved ticket properties');
                } else {
                    toast.error('Could not save ticket properties');
                }
            })
        });
    }

    handleFilesChanged = (file: File, status: string) => {
        let files = [...this.state.files];

        if (status == 'done') {
            files.push(file);
        }

        if (status == 'removed') {
            files = files.filter(x => x.name != file.name);
        }

        this.setState({
            files
        });
    }

    handleSubmit = () => {
        let subjectValid = this.state.subject != '';
        let messageValid = this.state.message != '';

        this.setState({
            subjectValid,
            messageValid
        }, () => {
            if (subjectValid && messageValid) {
                let { subject, message, files } = this.state;

                this.props.showLoading('Updating ticket, one moment please...').then(() => {
                    this.props.updateCenterTicket(this.props.id, subject, message, files).then(() => {
                        this.getData().then(() => {
                            toast.success('Message added successfully');
                        });
                    });
                });
            }
        });

    }

    getData = () => {
        return this.props.showLoading('Loading ticket, one moment please...').then(() => {
            return Promise.all([
                this.props.getTicket(this.props.id),
                this.props.getLookupData()
            ]).then(([ticketResponse, ticketLookupDataResponse]) => {
                if (ticketResponse.data.success && ticketLookupDataResponse.data.success) {
                    this.setState({
                        ticketTypes: ticketLookupDataResponse.data.results.ticketTypeList,
                        subject: '',
                        subjectValid: true,
                        message: '',
                        messageValid: true
                    }, () => {
                        this.props.hideLoading();

                        return Promise.resolve(null);
                    });
                }
            });
        });
    }

    render = () => {
        if (this.props.ticketing.ticket == null) {
            return null;
        }

        const messages = this.props.ticketing.ticket ? this.props.ticketing.ticket.messages : [];
        const noNotes = messages.filter(x => x.type != MessageType.Note);

        const sortedMessages = _.orderBy(noNotes, (message: ITicketMessage) => {
            return new Date(message.createdDateTime);
        }, ['asc']);

        const assignedUser = this.props.ticketing.ticket.assignedUser ?
            this.props.ticketing.ticket.assignedUser.firstName + ' ' + this.props.ticketing.ticket.assignedUser.lastName
            :
            '[Pending Assignment]';

        return (
            <>
                <div className='container'>
                    <div className='row'>
                        <div className='col-xs-12 col-lg-12' style={{ paddingLeft: 0, paddingRight: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div>
                                    <h1 style={{ marginBottom: 30 }}>View Ticket</h1>
                                </div>
                                <div>
                                    <Button bsStyle='link' onClick={this.handleReturnToList}>Return to List</Button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Well style={{ padding: '9.5px 25px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <DataSectionWrapper>
                                <LabelWrapper>Ticket #</LabelWrapper>
                                <DataWrapper>{this.props.ticketing.ticket.id}</DataWrapper>
                            </DataSectionWrapper>

                            <DataSectionWrapper>
                                <LabelWrapper>From</LabelWrapper>
                                <DataWrapper>{this.props.ticketing.ticket.contact != null ? this.props.ticketing.ticket.contact.fullName : ''}</DataWrapper>
                            </DataSectionWrapper>

                            <DataSectionWrapper>
                                <LabelWrapper>Assigned User</LabelWrapper>
                                <DataWrapper>{assignedUser}</DataWrapper>
                            </DataSectionWrapper>

                            <DataSectionWrapper>
                                <LabelWrapper>Entity Type</LabelWrapper>
                                <DataWrapper>{this.props.ticketing.ticket.entityTypeName}</DataWrapper>
                            </DataSectionWrapper>

                            <DataSectionWrapper>
                                <LabelWrapper>Status</LabelWrapper>
                                <FormControl
                                    componentClass='select'
                                    bsSize='small'
                                    value={this.props.ticketing.ticket.ticketStatusId}
                                    onChange={this.handleStatusChange}
                                >
                                    <option value={1}>Open</option>
                                    <option value={2}>Pending Response</option>
                                    <option value={3}>Closed</option>
                                </FormControl>
                            </DataSectionWrapper>

                            <DataSectionWrapper>
                                <LabelWrapper>Tier</LabelWrapper>
                                <DataWrapper>{this.props.ticketing.ticket.tierLevelName}</DataWrapper>
                            </DataSectionWrapper>

                            <DataSectionWrapper>
                                <LabelWrapper>Group</LabelWrapper>
                                <DataWrapper>{this.props.ticketing.ticket.groupName}</DataWrapper>
                            </DataSectionWrapper>
                        </div>
                    </Well>

                    <div className='row'>
                        <div className='col-xs-12 col-lg-6'>
                            {sortedMessages.map((message, index) =>
                                <div style={{ paddingLeft: index * 10 }}>
                                    <Message
                                        key={index}
                                        isCenter={true}
                                        ticket={this.props.ticketing.ticket}
                                        ticketMessage={message}
                                    />
                                </div>
                            )}
                        </div>

                        <div className='col-xs-12 col-lg-6'>
                            <Panel>
                                <Panel.Heading>Add Message</Panel.Heading>
                                <Panel.Body>
                                    <FormGroup validationState={this.state.subjectValid == false ? 'error' : null}>
                                        <ControlLabel>Subject</ControlLabel>
                                        <FormControl
                                            value={this.state.subject}
                                            onChange={this.handleSubjectChange}
                                        />
                                        {this.state.subjectValid == false && (
                                            <HelpBlock>Please specify the subject...</HelpBlock>
                                        )}
                                    </FormGroup>

                                    <FormGroup validationState={this.state.messageValid == false ? 'error' : null}>
                                        <ControlLabel>Message</ControlLabel>
                                        <FormControl
                                            componentClass='textarea'
                                            style={{ height: 200, resize: 'none' }}
                                            value={this.state.message}
                                            onChange={this.handleMessageChange}
                                        />
                                        {this.state.messageValid == false && (
                                            <HelpBlock>Please specify the message...</HelpBlock>
                                        )}
                                    </FormGroup>

                                    <FormGroup>
                                        <ControlLabel>Attachments</ControlLabel>
                                        <div style={{ border: '1px solid #ddd', borderRadius: 4 }}>
                                            <MyUploader hideBorder={true} filesChanged={this.handleFilesChanged} />
                                        </div>
                                    </FormGroup>

                                    <div className='text-right'>
                                        <Button bsStyle='primary' onClick={this.handleSubmit}>Add Message</Button>
                                    </div>
                                </Panel.Body>
                            </Panel>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        ticketing: state.ticketing,
        centers: state.centers
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getTicket: (ticketId) => {
            return dispatch(TicketingActionCreators.getTicket(ticketId));
        },
        getLookupData: () => {
            return dispatch(TicketingActionCreators.getLookupData());
        },
        updateCenterTicket: (id, subject, message, files) => {
            return dispatch(TicketingActionCreators.updateCenterTicket(id, subject, message, files));
        },
        updateTicket: (property, value) => {
            dispatch(TicketingActionCreators.updateTicket(property, value));
        },
        saveTicketProperties: () => {
            return dispatch(TicketingActionCreators.saveTicketProperties());
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(ViewCenterTicket);
